import { RARITY_COLORS } from '../../data/items';
import { LootCard } from '../atoms/LootCard';

/**
 * ChestLootModal — shown when the player opens a treasure chest.
 *
 * Presents 3 guaranteed item drops; the player picks one to keep.
 * The unchosen items are discarded.
 *
 * Props:
 *   items    — array of 3 item objects from rollChestItem()
 *   onChoose — (itemObj) → void
 */
export function ChestLootModal({ items, onChoose }) {
  return (
    <div className="chest-modal-overlay">
      <div className="chest-modal">
        <h2 className="chest-modal-title">📦 Treasure Found!</h2>
        <p className="chest-modal-sub">Choose one item to keep — the rest vanish.</p>

        <div className="chest-modal-items">
          {(items ?? []).map((item, i) => (
            <LootCard
              key={i}
              item={item}
              color={RARITY_COLORS[item.rarity] ?? '#9e9e9e'}
              onChoose={() => onChoose(item)}
            />
          ))}
        </div>

        <p className="chest-modal-warning">⚠️ 40 enemies are converging on your location!</p>
      </div>
    </div>
  );
}
